import { ConfirmationModal, Text } from '@shared/components';

interface QSetMarkExamUsageAsReadyModalProps {
  selectedQSets: string[];
  open: boolean;
  onClose: () => void;
  handleSubmit: (qsetId: string[]) => Promise<void>;
  loading: boolean;
}

export default function QSetMarkExamUsageAsReadyModal(
  props: Readonly<QSetMarkExamUsageAsReadyModalProps>,
) {
  const { open, onClose, selectedQSets, handleSubmit, loading } = props;

  return (
    <ConfirmationModal
      open={open}
      title='Mark as Ready?'
      loading={loading}
      content={
        <Text>
          คุณกำลังจะเปลี่ยนสถานะของชุดข้อสอบจำนวน {selectedQSets.length} ชุด ให้เป็น{' '}
          <Text variant='body1Semibold'>{'Ready\n'}</Text>
          {'เพื่อเตรียมความพร้อมสำหรับการจัดสอบ\nกรุณาตรวจสอบความถูกต้องก่อนดำเนินการต่อ'}
        </Text>
      }
      acceptText='Mark as Ready'
      onAccept={() => handleSubmit(selectedQSets)}
      onDiscard={onClose}
      onClose={onClose}
    />
  );
}
